const APP_ID = process.env.APP_ID;
const GOOGLE_PLAY_URL = process.env.GOOGLE_PLAY_URL;

const freeOffer = {
  '@type': 'Offer',
  price: '0',
  priceCurrency: 'USD',
};

const mobileApplicationMarkupSchema = () => [
  {
    '@type': 'MobileApplication',
    '@id': `https://apps.apple.com/us/app/id${APP_ID}#app`,
    name: 'Quran Pro',
    operatingSystem: 'iOS',
    applicationCategory: 'LifestyleApplication',
    installUrl: `https://apps.apple.com/us/app/id${APP_ID}`,
    offers: freeOffer,
  },
  {
    '@type': 'MobileApplication',
    '@id': `${GOOGLE_PLAY_URL}#app`,
    name: 'Quran Pro',
    operatingSystem: 'ANDROID',
    applicationCategory: 'LifestyleApplication',
    installUrl: GOOGLE_PLAY_URL,
    offers: freeOffer,
  },
];

export default mobileApplicationMarkupSchema;
